import { useEffect, useState } from "react";
import Title from "../../../components/common/title/Title";
import { getApi } from "../../../services/api/globalApi";
import { digitsThree } from "../../../utils/price";
import OrdersReportsFilter from "./OrdersReportsFilter";
import ExportExcel from "../../../components/common/export-exel/ExportExel";

export default function OrdersReports() {
  const [reportsData, setReportsData] = useState(null);

  const getOrdersReports = async (params) => {
    const path = "/admin/reports/getOrderSalesPriceReport";
    try {
      const response = await getApi({ path, params: { ...params } });
      setReportsData(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOrdersReports({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getOrdersReports(allFilter);
  };


  return (
    <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 md:p-8">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Title title={"گزارش فروش سفارشات"} />
        <ExportExcel jsonData={[{
          "تعداد فروش": reportsData?.count ?? "",
          "فروش خالص": reportsData?.foroshKhales ?? "",
          "فروش ناخالص": reportsData?.foroshNaKhales ?? "",
        }]} />
      </div>
      <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">تعداد سفارش‌های پرداخت‌شده و مجموع فروش خالص و ناخالص را بر اساس تاریخ پرداخت و نقش کاربر نشان می‌دهد.</p>
      <OrdersReportsFilter filterDataHandler={filterDataHandler} />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="rounded-xl border border-blue-100 bg-blue-50 p-5 dark:border-blue-900 dark:bg-blue-950/40">
          <p className="text-sm text-slate-600 dark:text-slate-300">تعداد فروش</p>
          <span className="mt-3 block text-2xl font-bold text-blue-700 dark:text-blue-300">{reportsData?.count}</span>
        </div>
        <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-5 dark:border-emerald-900 dark:bg-emerald-950/40">
          <p className="text-sm text-slate-600 dark:text-slate-300">فروش خالص</p>
          <span className="mt-3 block text-2xl font-bold text-emerald-700 dark:text-emerald-300">{digitsThree(reportsData?.foroshKhales)}</span>
        </div>
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-5 dark:border-slate-700 dark:bg-slate-800/60">
          <p className="text-sm text-slate-600 dark:text-slate-300">فروش ناخالص</p>
          <span className="mt-3 block text-2xl font-bold text-slate-800 dark:text-slate-100">{digitsThree(reportsData?.foroshNaKhales)}</span>
        </div>
      </div>
    </div>
  );
}
